export default __webpack_public_path__ + "static/media/OnRollLogo-white.b38c6bd7.svg";